export var AddressSelectionMode;
(function (AddressSelectionMode) {
    // Unambiguous — assign the type directly
    AddressSelectionMode["Auto"] = "auto";
    // One address spans many networks of this type — user picks networks
    AddressSelectionMode["Networks"] = "networks";
    // Address format shared with other providers — user disambiguates the type (Starknet, Fuel)
    AddressSelectionMode["Overlap"] = "overlap";
})(AddressSelectionMode || (AddressSelectionMode = {}));
// Local copy of the network type values (mirrors Models/Network.ts in the widget).
// Kept here so utils does not depend on @layerswap/widget.
export var NetworkType;
(function (NetworkType) {
    NetworkType["EVM"] = "evm";
    NetworkType["Starknet"] = "starknet";
    NetworkType["Solana"] = "solana";
    NetworkType["Cosmos"] = "cosmos";
    NetworkType["StarkEx"] = "starkex";
    NetworkType["TON"] = "ton";
    NetworkType["Fuel"] = "fuel";
    NetworkType["Bitcoin"] = "bitcoin";
    NetworkType["Tron"] = "tron";
    NetworkType["Hyperliquid"] = "hyperliquid";
    NetworkType["Polymarket"] = "polymarket";
})(NetworkType || (NetworkType = {}));
